import {MutationOptions as BaseMutationOptions, QueryOptions as BaseQueryOptions, OperationVariables} from "apollo-client"
export type {PureQueryOptions} from "apollo-client"

export type {ApolloLoad} from "./helpers/hookShared"
export type {UseQueryExtend} from "./useQuery"
export {createUseQuery} from "./useQuery"
export {useQuerys} from "./helpers/useQuerys"
export {createUseLazyQuery} from "./useLazyQuery"
export type {UseMutationExtractor} from "./useMutation"
export {createUseMutation} from "./useMutation"

import client, {unauthedClient} from "./client"
import Query from "./Query"
import Mutation from "./Mutation"
import {Provider as ApolloProvider} from "./Provider"
import pagination, {emptyList} from "./helpers/pagination"
import hasMorePagination from "./helpers/hasMorePagination"
import cursorPagination from "./helpers/cursorPagination"

export interface MutationOptions<T = any, TVariables = OperationVariables>
  extends Omit<BaseMutationOptions<T, TVariables>, "mutation" | "variables"> {}

export interface QueryOptions<TVariables = OperationVariables> extends Omit<BaseQueryOptions<TVariables>, "query" | "variables"> {}

export default client
export {Query, Mutation, ApolloProvider, pagination, hasMorePagination, cursorPagination, emptyList, unauthedClient}
